'use client'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

/**
 * Returns the current browser URL, updating on client-side route changes.
 * Prefer absolute URL so active-nav host matching works.
 */
const useCurrentUrl = () => {
  const router = useRouter()
  const [currentURL, setCurrentURL] = useState(null)

  useEffect(() => {
    if (typeof window === 'undefined') return
    setCurrentURL(window.location.origin + router.asPath)
  }, [router.asPath])

  return currentURL
}

export { useCurrentUrl }
